
//#region src/richtext/asText.ts
/**
* Converts a rich text field to a plain text string.
*
* @param richTextField - A rich text field from Prismic.
* @param separator - Separator used to join each element. Defaults to a space.
*
* @returns Plain text equivalent of the rich text field.
*
* @see Learn how to work with rich text fields: {@link https://prismic.io/docs/fields/rich-text}
*/
const asText = (richTextField, separator = " ") => {
	let result = "";
	for (let i = 0; i < richTextField.length; i++) if ("text" in richTextField[i]) result += (result ? separator : "") + richTextField[i].text;
	return result;
};

//#endregion
exports.asText = asText;
//# sourceMappingURL=asText.cjs.map